import React, { useContext } from 'react';
import { Fancybox } from '@fancyapps/ui';
import { LocaleContext, TLocaleContext } from '@@contexts/LocaleContext';
import { TImage, TGallery } from '@@config/wcs';
import i18n from './i18n.json';

type TImageGalleryProps = {
    media: TGallery;
};

const ImageGallery: React.FC<TImageGalleryProps> = ({ media }) => {
    const { locale }: TLocaleContext = useContext(LocaleContext);
    const { PRIMARY_IMAGE, GALLERY_IMAGES } = media;

    const createFancyGallery = (): void => {
        const fancyGallerySlides = GALLERY_IMAGES.map((image: TImage) => {
            return { src: image.SRC, caption: image.CAPTION ?? image.ALT_TEXT };
        });

        Fancybox.show(fancyGallerySlides, { hideScrollbar: true });
    };

    return (
        <div className='relative py-4'>
            <div className='galleryModule'>
                <button className='btn btn-secondary center-block rounded' onClick={createFancyGallery}>
                    {i18n['viewGallery'][locale] ?? 'View Gallery'}
                </button>
                <img className='h-auto max-w-full' src={PRIMARY_IMAGE.SRC} alt={PRIMARY_IMAGE.ALT_TEXT} />
            </div>
        </div>
    );
};

export default ImageGallery;
